import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MIN_STATUS } from '../../../../../shared/utils/constants';
import { DocumentationSectionModel } from '../../../../models/documentation-section.model';
import { DashboardSectionService } from '../../../../services/dashboard-section/dashboard-section.service';

@Component({
  selector: 'app-documentation-section',
  templateUrl: './documentation-section.component.html',
  styleUrls: ['./documentation-section.component.scss'],
  standalone: false,
})
export class DocumentationSectionComponent implements OnInit, OnChanges {
  @Input() status: number;
  @Input() isRejected: boolean;

  public documentState: DocumentationSectionModel;
  public httpError: boolean;
  public minStatus = MIN_STATUS;

  constructor(private dashboardSectionService: DashboardSectionService) {}

  ngOnInit() {
    this.getDocumentationData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.status) {
      this.getDocumentationData();
    }
  }

  private getDocumentationData() {
    if (this.status >= this.minStatus.attachDocumentation) {
      this.dashboardSectionService.getDocumentationSectionData().subscribe(
        (response) => {
          this.documentState = response;
        },
        (error) => (this.httpError = true),
      );
    }
  }
}
